import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Card,
	Modal, ModalBody, ModalFooter, ModalHeader,
	Spinner,
	Button
} from 'reactstrap'
import Http from '../Http'
import { Line, Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { FormatNumberInEur, CalcDeltaChart } from '../components/Utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

class SingleDemo extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			chartEXPData: {
				datasets: [],
				labels: [],
			},
			chartEXPOptions: {
				plugins: {
					datalabels: {
						color: '#fff'
					}
				},
				scales: {
					yAxes: [{
						ticks: {
							maxTicksLimit: 5,
							min: 0,
							max: 100,
							fontColor: "#fff"
						}
					}],
					xAxes: [{
						ticks: {
							fontColor: "#fff"
						}
					}]
				},
				legend: {
					display: false
				},
				aspectRatio: 1.4,
			},
			chartCCBData: {
				datasets: [],
				labels: [],
			},
			chartCCBOptions: {
				scales: {
					yAxes: [{
						ticks: {
							maxTicksLimit: 5,
							min: -30,
							max: 45,
							fontColor: "#fff"
						}
					}],
					xAxes: [{
						ticks: {
							fontColor: "#fff"
						}
					}]
				},
				legend: {
					display: false
				},
				aspectRatio: 1.4,
				plugins: {
					datalabels: {
						color: '#fff',
						align: 'top'
					}
				},
			},
			chartRatingData: {
				datasets: [],
				labels: [],
			},
			chartRatingOptions: {
				annotation: {
					annotations: [
						{
							type: "line",
							mode: "horizontal",
							scaleID: "y-axis-0",
							value: '23',
							borderColor: "rgba(170,170,170,0.5)",
							borderDash: [20, 15],
							label: {
								backgroundColor: 'rgba(0,0,0,0)',
								fontColor: "rgba(170, 211, 255, 1)",
								fontStyle: "bold",
								content: "Rischio Elevato",
								enabled: true,
								position: "right"
							}
						},
						{
							type: "line",
							mode: "horizontal",
							scaleID: "y-axis-0",
							value: '31',
							borderColor: "rgba(170,170,170,0.5)",
							borderDash: [20, 15],
							label: {
								backgroundColor: 'rgba(0,0,0,0)',
								fontColor: "rgba(170, 211, 255, 1)",
								fontStyle: "bold",
								content: "Rischio Alto",
								enabled: true,
								position: "right"
							}
						}, {
							type: "line",
							mode: "horizontal",
							scaleID: "y-axis-0",
							value: '39',
							borderColor: "rgba(170,170,170,0.5)",
							borderDash: [20, 15],
							label: {
								backgroundColor: 'rgba(0,0,0,0)',
								fontColor: "rgba(170, 211, 255, 1)",
								fontStyle: "bold",
								content: "Rischio Medio",
								enabled: true,
								position: "right"
							}
						},
						{
							type: "line",
							mode: "horizontal",
							scaleID: "y-axis-0",
							value: '47',
							borderColor: "rgba(170,170,170,0.5)",
							borderDash: [20, 15],
							label: {
								backgroundColor: 'rgba(0,0,0,0)',
								fontColor: "rgba(170, 211, 255, 1)",
								fontStyle: "bold",
								content: "Rischio Basso",
								enabled: true,
								position: "right"
							}
						}, {
							type: "line",
							mode: "horizontal",
							scaleID: "y-axis-0",
							value: '60',
							borderColor: "rgba(170,170,170,0.5)",
							borderDash: [20, 15],
							label: {
								backgroundColor: 'rgba(0,0,0,0)',
								fontColor: "rgba(170, 211, 255, 1)",
								fontStyle: "bold",
								content: "Rischio Nullo",
								enabled: true,
								position: "right"
							}
						}
					]
				},
				scales: {
					yAxes: [{
						ticks: {
							maxTicksLimit: 5,
							min: 0,
							max: 65,
							fontColor: "#fff"
						}
					}],
					xAxes: [{
						ticks: {
							fontColor: "#fff"
						}
					}]
				},
				legend: {
					display: false
				},
				aspectRatio: 1.4,
			},
			modalEXP: false,
			modalCCF: false,
			modalRating: false
		}
		this.api = '/api/v1';

	}

	componentDidMount() {
		Chart.plugins.unregister(ChartDataLabels);

		Http.get(`${this.api}/client/${this.props.user.companyId}`)
			.then((response) => {
				const { data } = response.data;
				if (data == []) {
					// alert('Si è verificato un errore: cliente non valido')
					this.setState({
						error: 'Si è verificato un errore: cliente non valido',
						loading: false
					});
				}
				this.setState({
					clientData: data,
				});
				this.loadChartsData()
			})

	}

	loadChartsData() {
		const { clientData } = this.state
		let datasetsChartEXP = [], labelsChartEXP = [],
			datasetsChartCCB = [], labelsChartCCB = [],
			datasetsChartRating = [], labelsChartRating = [];

		const EXPDataLength = clientData.chartEXPData.length
		datasetsChartEXP.push(
			{
				label: clientData.name,
				fill: false,
				lineTension: 0.1,
				backgroundColor: 'rgba(170, 211, 255, 0.6)',
				borderColor: 'rgba(170, 211, 255, 1)',
				data: [clientData.chartEXPData.slice(EXPDataLength - 2, EXPDataLength)][0] //tengo solo gli ultimi 2 anni
			})
		labelsChartEXP = clientData.chartEXPLabels.slice(EXPDataLength - 2, EXPDataLength)

		datasetsChartCCB.push(
			{
				label: clientData.name,
				fill: false,
				lineTension: 0.1,
				borderWidth: 1,
				borderColor: 'rgba(170, 211, 255, 1)',
				pointRadius: 3,
				pointHoverRadius: 5,
				pointHoverBorderWidth: 2,
				pointHoverBorderColor: 'rgba(170, 211, 255, 1)',
				pointBackgroundColor: 'rgba(170, 211, 255, 1)',
				data: [clientData.chartCCBData][0]
			})
		labelsChartCCB = clientData.chartCCBLabels

		datasetsChartRating.push(
			{
				label: clientData.name,
				fill: false,
				lineTension: 0.1,
				borderWidth: 1,
				borderColor: 'rgba(170, 211, 255, 1)',
				pointRadius: 3,
				pointHoverRadius: 5,
				pointHoverBorderWidth: 2,
				pointHoverBorderColor: 'rgba(170, 211, 255, 1)',
				pointBackgroundColor: 'rgba(170, 211, 255, 1)',
				data: [clientData.chartRatingData][0]
			})
		labelsChartRating = clientData.chartRatingLabels

		let { chartEXPData, chartCCBData, chartRatingData } = this.state

		chartEXPData.datasets = datasetsChartEXP
		chartEXPData.labels = labelsChartEXP
		chartCCBData.datasets = datasetsChartCCB
		chartCCBData.labels = labelsChartCCB
		chartRatingData.datasets = datasetsChartRating
		chartRatingData.labels = labelsChartRating

		this.setState({
			chartEXPData,
			chartCCBData,
			chartRatingData,
			loading: false
		})
	}

	toggleModalEXP = () => {
		this.setState({
			modalEXP: !this.state.modalEXP
		});
	};

	toggleModalCCF = () => {
		this.setState({
			modalCCF: !this.state.modalCCF
		});
	};

	toggleModalRating = () => {
		this.setState({
			modalRating: !this.state.modalRating
		});
	};

	render() {
		const { user } = this.props
		const { chartEXPData, chartEXPOptions, chartCCBData, chartCCBOptions, chartRatingData, chartRatingOptions, loading, clientData, modalEXP, modalCCF, modalRating } = this.state
		if (loading) {
			return (<div className="content pl-5 text-center">
				<Spinner style={{ width: '3rem', height: '3rem' }} type="grow" />
			</div>)
		}
		let expOutro

		if (clientData.chartEXPData[clientData.chartEXPData.length - 1] <= 20) {
			expOutro = " per conoscere quali sono i settori della tua azienda che attualmente frenano la crescita."
		} else if (clientData.chartEXPData[clientData.chartEXPData.length - 1] <= 40) {
			expOutro = " per conoscere quali sono i settori della tua azienda che, attualmente, non consentono una importante spinta alla crescita."
		} else if (clientData.chartEXPData[clientData.chartEXPData.length - 1] <= 70) {
			expOutro = " per conoscere quali sono le aree di intervento della tua azienda che, ulteriormente migliorate, possono dare una spinta importante alla tua crescita."
		} else {
			expOutro = " per conoscere quali sono le decisioni e azioni che, una volta prese, possono mantenere o migliorare la tua importante propensione alla crescita."
		}

		return (
			<div className="content pl-5" >
				<Row>
					<Col md="4">
						<Card className='p-3 border border-primary'>
							<Row>
								<Col md="12" className="mb-3">
									<h3 className="text-left mb-0"><span className='text-secondary'>EXP - </span>{clientData.chartEXPDataText[clientData.chartEXPDataText.length - 1]}</h3>
									<p className="text-left">Coefficiente di sviluppo futuro</p>
								</Col>
							</Row>
							<Bar height={200} width={null}
								data={chartEXPData}
								options={chartEXPOptions}
								plugins={[ChartDataLabels]} />
							<p className='mt-5'>L' <span className='font-bold text-primary'>EXP</span> è la propensione alla crescita dell'azienda.</p>
							<Button className='btn btn-sm my-2' onClick={this.toggleModalEXP}>Approfondisci</Button>
							<Modal
								isOpen={modalEXP}
								toggle={this.toggleModalEXP}
							>
								<ModalHeader className="bg-primary pb-4" toggle={this.toggleModalEXP}><span className='h2'>EXP</span></ModalHeader>
								<ModalBody className="bg-primary" >
									<p className='h4 text-justify'><span className='font-weight-bold'>Contatta un nostro Specialist</span>{expOutro}</p>
								</ModalBody>
								<ModalFooter className="bg-primary py-2">
									<Row>
										<Col sm="9">
											<p className='lead'>Clicca il pulsante per visualizzare le nostre disponbilità e pianificare una videocall. Oppure scrivi per email a info@qoobi.it</p>
										</Col>
										<Col sm="3">
											<a className='btn btn-sm' href='https://cal.qsuite.eu' target={"_blank"}>Contattaci</a>
										</Col>
									</Row>
								</ModalFooter>
							</Modal>
						</Card>
					</Col>
					<Col md="4">
						<Card className='p-3'>
							<Row>
								<Col md="12" className="mb-3">
									<h3 className="text-left mb-0"><span className='text-secondary'>CCF - </span>{clientData.chartCCBDataText[clientData.chartCCBDataText.length - 1]}</h3>
									<p className="text-left">Coefficiente di crescita Finanziaria</p>
								</Col>
							</Row>
							<Line data={chartCCBData} height={200} width={null} options={chartCCBOptions}
								plugins={[ChartDataLabels]} />
							<p className='mt-5'>Il <span className='font-bold text-primary'>CCF</span> indica la propensione dell'azienda ad investire.</p>
							<button className='btn btn-sm my-2' onClick={this.toggleModalCCF}>Approfondisci</button>
							<Modal
								isOpen={modalCCF}
								toggle={this.toggleModalCCF}
							>
								<ModalHeader className="bg-primary pb-4" toggle={this.toggleModalCCF}><span className='h2'>CCF</span></ModalHeader>
								<ModalBody className="bg-primary" >
									<p className='h4 font-weight-bold text-justify'>Il CCF va da -20 a 35 e {user.company} presenta un valore {clientData.chartCCBLabels[clientData.chartCCBLabels.length - 1]} di <span className='font-weight-bold'>{clientData.chartCCBData[clientData.chartCCBData.length - 1]}</span>. </p>
								</ModalBody>
								<ModalFooter className="bg-primary py-2">
									<Row>
										<Col sm="9">
											<p className='lead'>Clicca il pulsante per visualizzare le nostre disponbilità e pianificare una videocall. Oppure scrivi per email a info@qoobi.it</p>
										</Col>
										<Col sm="3">
											<a className='btn btn-sm' href='https://cal.qsuite.eu' target={"_blank"}>Contattaci</a>
										</Col>
									</Row>
								</ModalFooter>
							</Modal>
						</Card>
					</Col>
					<Col md="4" >
						<Card className='p-3'>
							<Row>
								<Col md="12" className="mb-3">
									<h3 className="text-left mb-0"><span className='text-secondary'>Rating - </span>{clientData.chartRatingDataText[clientData.chartRatingDataText.length - 1]} {clientData.chartRatingDataRischio[clientData.chartRatingDataRischio.length - 1]}</h3>
									<p className="text-left">Livello di rischio</p>
								</Col>
							</Row>
							<Line data={chartRatingData} height={200} width={null} options={chartRatingOptions} />
							<p className='mt-5'>Il <span className='font-bold text-primary'>Rating</span> indica il livello di rischio della azienda.</p>
							<button className='btn btn-sm my-2' onClick={this.toggleModalRating}>Approfondisci</button>
							<Modal
								isOpen={modalRating}
								toggle={this.toggleModalRating}
							>
								<ModalHeader className="bg-primary pb-4" toggle={this.toggleModalRating}><span className='h2'>Rating</span></ModalHeader>
								<ModalBody className="bg-primary" >
									<p className='h4 font-weight-bold text-justify'>Il Rating ha una scala che va da QA (rischio nullo) a QE (rischio elevato). La scala Rating presenta 13 valori e 5 livelli di rischio. (Alto profilo per l’elevato livello di dettaglio). </p>
								</ModalBody>
								<ModalFooter className="bg-primary py-2">
									<Row>
										<Col sm="9">
											<p className='lead'>Clicca il pulsante per visualizzare le nostre disponbilità e pianificare una videocall. Oppure scrivi per email a info@qoobi.it</p>
										</Col>
										<Col sm="3">
											<a className='btn btn-sm' href='https://cal.qsuite.eu' target={"_blank"}>Contattaci</a>
										</Col>
									</Row>
								</ModalFooter>
							</Modal>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col md="12" className='text-right'>
						<a target="_blank" href='https://qsuite.eu'>Scopri la piattaforma Qsuite <FontAwesomeIcon icon={faChevronRight} /></a>
					</Col>
				</Row>
			</div >

		)
	}
}

SingleDemo.propTypes = {
	dispatch: PropTypes.func.isRequired,
	isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
	isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(SingleDemo);